module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert J. Allison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robert J. Allison")]), _vm._v(" is chair of the Department of History, university archivist, and director of American Studies at Suffolk University.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3ztkaC/tc-custom/9780226308579.jpg?1722572676463",
      "alt": "This image is the cover for the book Crescent Obscured, The Legacy of the Barbary Wars"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crescent Obscured, The Legacy of the Barbary Wars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From the beginning of the colonial period to the recent conflicts in the Middle East, encounters with the Muslim world have helped Americans define national identity and purpose. Focusing on America's encounter with the Barbary states of North Africa from 1776 to 1815, Robert Allison traces the perceptions and mis-perceptions of Islam in the American mind as the new nation constructed its ideology and system of government."), _c('br'), _c('br'), _vm._v(" \"A powerful ending that explains how the experience with the Barbary states compelled many Americans to look inward . . . with increasing doubts about the institution of slavery.\" —David W. Lesch, "), _c('i', [_vm._v("Middle East Journal")]), _c('br'), _c('br'), _vm._v(" \"Allison's incisive and informative account of the fledgling republic's encounter with the Muslim world is a revelation with a special pertinence to today's international scene.\" —Richard W. Bulliet, "), _c('i', [_vm._v("Journal of Interdisciplinary History")]), _c('br'), _c('br'), _vm._v(" \"This book should be widely read. . . . Allison's study provides a context for understanding more recent developments, such as America's tendency to demonize figures like Iran's Khumaini, Libya's Qaddafi, and Iraq's Saddam.\" —Richard M. Eaton, "), _c('i', [_vm._v("Eighteenth Century Studies")]), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0